// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"JJXTp","dropdown":"mYnjz","floatingDropdown":"_1CSs-","divider":"X_Zjq","tabs":"_3NsH_","cart-button":"_3CSTt","cartButton":"_3CSTt"};